import { Button, Grid, MenuItem, TextField } from '@mui/material'
import { useCallback, useState } from 'react'
import Programa from '../../../components/Programa/Programa'
import { metodoPrograma } from '../../../components/api'

const meses = [
  { value: 1, label: 'JANEIRO' },
  { value: 2, label: 'FEVEREIRO' },
  { value: 3, label: 'MARÇO' },
  { value: 4, label: 'ABRIL' },
  { value: 5, label: 'MAIO' },
  { value: 6, label: 'JUNHO' },
  { value: 7, label: 'JULHO' },
  { value: 8, label: 'AGOSTO' },
  { value: 9, label: 'SETEMBRO' },
  { value: 10, label: 'OUTUBRO' },
  { value: 11, label: 'NOVEMBRO' },
  { value: 12, label: 'DEZEMBRO' },
]

const RelatorioAniversariantes = () => {
  const [nrMes, setNrMes] = useState(() => new Date().getMonth() + 1)
  const [loading, setLoading] = useState(false)

  const emiteRelatorio = useCallback(() => {
    if (!nrMes) return

    setLoading(true)

    metodoPrograma('geraRelatorio', {
      nrMes,
    })
      .then((res) => {
        if (res.status) {
          const base64 = res.arquivo

          const byteCharacters = atob(base64)
          const byteNumbers = new Array(byteCharacters.length)

          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i)
          }

          const byteArray = new Uint8Array(byteNumbers)

          const blob = new Blob([byteArray], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          })

          const url = window.URL.createObjectURL(blob)
          const link = document.createElement('a')

          link.href = url
          link.download = 'relatorio_aniversariantes.xlsx'
          document.body.appendChild(link)
          link.click()

          link.remove()
          window.URL.revokeObjectURL(url)
        }
      })
      .finally(() => setLoading(false))
  }, [nrMes])

  return (
    <Programa codigo="CtrlRelatorioAniversarianteDoMes">
      <Grid container spacing={2} style={{ marginTop: 50 }}>
        <Grid item xs={12} md={3}></Grid>

        <Grid item xs={12} md={6}>
          <TextField
            label="Mês"
            select
            margin="dense"
            variant="outlined"
            size="small"
            fullWidth
            InputLabelProps={{ shrink: true }}
            value={nrMes}
            onChange={(e) => setNrMes(Number(e.target.value))}
          >
            {meses.map((mes) => (
              <MenuItem key={mes.value} value={mes.value}>
                {mes.label}
              </MenuItem>
            ))}
          </TextField>
        </Grid>

        <Grid item xs={12} md={3}></Grid>

        <Grid item xs={3}></Grid>

        <Grid item xs={6} style={{ marginTop: 50 }}>
          <Button
            variant="contained"
            color="primary"
            fullWidth
            onClick={emiteRelatorio}
            disabled={loading || !nrMes}
          >
            {loading ? 'Gerando...' : 'Emitir Relatório'}
          </Button>
        </Grid>
      </Grid>
    </Programa>
  )
}

export default RelatorioAniversariantes
